/**
 * Deliberately a local constant rather than a member of the shared
 * `DraggableItem` enum: DragAndDropCustomDragLayer renders `null` for item
 * types it doesn't know, so dragging inside this modal falls back to the
 * browser's own drag preview instead of a fixed-position custom layer that
 * would sit underneath the modal.
 */
export const MANAGE_GROUPS_OFFERING_DRAG_TYPE = 'MANAGE_GROUPS_OFFERING';

export type ManageGroupsOfferingDragItem = {
  quoteOfferingId: string;
  /** Row the chip was dragged from; null when dragged out of Ungrouped */
  fromRowKey: string | null;
};

/**
 * Ship To, Bill To, offerings — the card's expanded body, where every one of
 * them is editable. The card's header strip is the part that stays on screen
 * when the card is collapsed, and stands in with read-only popovers over the
 * same values.
 *
 * Each of Ship To / Bill To stacks its account over its contact rather than
 * taking a column each: four side-by-side selects made it ambiguous which was
 * which, and squeezed the offerings — the thing you actually read while dragging.
 */
export const MANAGE_GROUPS_GRID_TEMPLATE_COLUMNS =
  'minmax(13rem, 1fr) minmax(13rem, 1fr) minmax(24rem, 2.2fr)';

/**
 * Floor width for the group cards — the sum of the template's minimums plus gaps
 * and card padding. Narrower viewports scroll the list horizontally instead of
 * collapsing the columns.
 */
export const MANAGE_GROUPS_MIN_WIDTH = '54rem';

/**
 * Launcher label and modal title, shared so the two can't drift: the screen only
 * claims to manage groups when something on it can actually be changed.
 */
export const getManageGroupsTitle = (isReadOnly: boolean) =>
  isReadOnly ? 'View Groups' : 'Manage Groups';
